import { useCallback, useState } from "react";
import ReportService from "../../../services/reportGeneration";
import { useDownloadReport } from "../../../lib/hooks/useDownloadReport";
import { useOpenProgressModal } from "../../../lib/hooks/useOpenProgressModal";
import { SUCCESS_PDF_DOWNLOAD } from "../../../lib/constants";

export const usePrintEnvelope = (customerId: string, addressType: 1 | 2) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { download } = useDownloadReport(setIsLoading);

  const { openModal } = useOpenProgressModal(
    "Generating Envelope Report",
    "Generating Envelope Report failed",
    (id?: string) => download(ReportService, id),
    {
      customMsg: SUCCESS_PDF_DOWNLOAD,
    },
  );

  const print = useCallback(async () => {
    try {
      setIsLoading(true);

      const request = {
        customerId,
        addressType,
      };

      const id: string = await ReportService.generateReportByName(
        "Envelope",
        request,
      );

      openModal(id);
    } catch {
      setIsLoading(false);
    }
  }, [addressType, customerId, openModal]);

  return { isLoading, print };
};
